import LocalStorageUtils from '../../js/lib/LocalStorageUtils';
import { getGProfile } from '../../js/actions';

const G_CLIENT_ID = '458880924025-qf3mat7ti0f804fc3c5tb6dqlk2jm1h5.apps.googleusercontent.com';

export const G_PROFILE_KEY = 'gProfile';

function getTokenClient(onLoadSuccess, onLoginSuccess, mode, clientId) {
  const client = window.google.accounts.id.initialize({
    client_id: clientId,
    scope: 'openid, profile, email',
    callback: onLoginSuccess,
  });
  renderSignInButton(mode);
  if (onLoadSuccess) {
    onLoadSuccess();
  }
}

function loadGAPI(onLoadSuccess, onLoginSuccess = null, mode, clientId) {
  if (typeof window.google === 'undefined') {
    ((doc, scr, scrId, cb) => {
      const element = doc.getElementsByTagName(scr)[0];
      const fjs = element;
      let js = element;
      js = doc.createElement(scr);
      js.id = scrId;
      js.async = true;
      js.defer = true;
      js.src = 'https://accounts.google.com/gsi/client';
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = cb;
    })(document, 'script', 'google-login', () => {
      getTokenClient(onLoadSuccess, onLoginSuccess, mode, clientId);
    });
  } else {
    getTokenClient(onLoadSuccess, onLoginSuccess, mode, clientId);
  }
}

function renderSignInButton(mode) {
  const googleButton = document.getElementById('loginGoogle');
  const width = googleButton?.dataset?.width ? Number(googleButton.dataset.width) : 400;
  if (window.google && window.google.accounts) {
    window.google.accounts.id.renderButton(googleButton, {
      theme: 'outline',
      text: mode === 'signin' ? 'signin_with' : 'signup_with',
      size: 'large',
      width,
    });
  }
}

function signOut(callback = null) {
  let auth2 = window.gapi.auth2.getAuthInstance();

  if (auth2 && auth2.isSignedIn.get()) {
    auth2.signOut().then(function () {
      if (callback) {
        callback();
      }
    });
  } else {
    if (callback) {
      callback();
    }
  }
}

function signOutGoogle(callback = null, clientId = G_CLIENT_ID) {
  if (typeof window.gapi === 'undefined') {
    loadGAPI(
      () => signOut(callback),
      () => {
        if (callback) callback();
      },
      clientId,
    );
  } else {
    signOut(callback);
  }
}

function getAuthStatus() {
  const profile = LocalStorageUtils.getObject(G_PROFILE_KEY);
  if (profile) {
    return {
      isGAuthLoggedIn: true,
      gAuthUser: getGProfile(profile),
      gToken: null,
    };
  }
  return {
    isGAuthLoggedIn: false,
    gAuthUser: null,
    gToken: null,
  };
}

function initGapi(onLoadSuccess, onLoginSuccess = null, mode = 'signin', clientId = G_CLIENT_ID) {
  loadGAPI(onLoadSuccess, onLoginSuccess, mode, clientId);
}

export default {
  signOutGoogle: signOutGoogle,
  renderSignInButton: renderSignInButton,
  getAuthStatus: getAuthStatus,
  initGapi: initGapi,
};
